export enum eNavSubMode {
    FULL = "FULL",
    POPUP = "POPUP"
}